<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> /<a href="javascript:void(0)" style="color:#888888" @click="urlTo('applyIndex')"> 个人办事</a> / <span style="color:#2e2e2e">{{nav_name}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="advice" >
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign8.png">{{nav_name}}</span><em><img src="../../../static/images/required.png">为必填项</em></h2>
            <dl class="advice_tips" style="color: red">
              <dt>温馨提示</dt>
              <dd> 1、特困救助金发放到申请人个人账户，护理费发放到护理人（机构）账户；</dd>
              <dd> 2、此工具根据相关政策文件进行的粗略测算，测算金额不是实际办理结果。</dd>

            </dl>
            <el-form  :rules="rules" :model="ruleForm" label-width="100px" ref="ruleForm" class="demo-ruleForm">
              <table width="90%" border="0" cellspacing="0" cellpadding="0" class="advice_tab">
                <tr >
                  <td style="width: 202px;">
                    <el-form-item  label="受理单位" prop="selectedRegions">
                      <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"   @change="onSelectedRegion" placeholder="请选择受理单位" clearable style="width: 200px;"></el-cascader>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item  label="户籍性质：" prop="BLANTypeCode">
                      <el-select
                        v-model="ruleForm.BLANTypeCode"
                        collapse-tags
                        placeholder="请选择" style="width: 200px;">
                        <el-option
                          v-for="item in BLANType"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>

                </tr>
                <tr >
                  <td style="width: 202px;">
                    <el-form-item  label="供养方式：" prop="ORPTypeCode">
                      <el-select
                        v-model="ruleForm.ORPTypeCode"
                        collapse-tags
                        placeholder="请选择" style="width: 200px;">
                        <el-option
                          v-for="item in ORPType"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item  label="能力等级：" prop="NTFTypeCode">
                      <el-select
                        v-model="ruleForm.NTFTypeCode"
                        collapse-tags
                        placeholder="请选择" style="width: 200px;">
                        <el-option
                          v-for="item in NTFType"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code" >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </td>

                </tr>



                <tr>
                  <td colspan="3"  >
                    <el-button :loading="loading" type="primary" @click="search" style=" width: 120px;
    margin-left: 100px;" :disabled="disableds">计算</el-button>

                  </td>
                </tr>

              </table>
            </el-form>
            <div v-if="totalShow" style="color: red;font-weight: 600;padding-left: 8%;padding-right: 8%;padding-top: 20px">
              预估你可以领取的特困生活费为：{{total.rescueAmount}}元/月，特困护理费为：{{total.nursAmount}}元/月， 具体以实际办理结果为准。

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "suggests",
    components:{
      headers,fixedDiv,footers
    },

    data() {
      let _self=this;
      return {
        disableds:false,
        totalShow:false,
        loading:false,
        total:'',
        NTFType:[
          {code:'1',name:'能力完好'},
          {code:'2',name:'轻度失能'},
          {code:'3',name:'中度失能'},
          {code:'4',name:'重度失能'},
        ],
        ORPType:[
          {code:'1',name:'分散供养'},
          {code:'0',name:'集中供养'},
        ],
        selectedRegion:[],
        BLANType:[
          {code:'1',name:'城市户口'},
          {code:'0',name:'农村户口'},
        ],

        ruleForm:{
          // selecteddepartOption:[],
          theTitle:'',
          types:'',
          BLANTypeCode:'',
          NTFTypeCode:'',
          ORPTypeCode:'',
          textarea:'',
          age:'',
          phone:'',
          verifyCode:'',
          smsCode:'',
        },
        rules:{
          selectedRegions:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          age:[{required:true ,validator:this.checkAge,tigger:'blur'}],
          BLANTypeCode:[{required:true ,message:'请选择户籍性质',tigger:'blur'}],
          NTFTypeCode:[{required:true ,message:'请选择能力等级',tigger:'blur'}],
          ORPTypeCode:[{required:true ,message:'请选择供养方式',tigger:'blur'}],

        },



        props: {
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              //   if(node.value=='63010001'){
              //     const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 3}];
              //     resolve(nodes);
              //   }else{
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              //   }
              // }else{
              //   // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   // resolve(nodes);
              //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },

      }
    } ,

    watch: {
      width(n, o) {
        alert(n + 'w')
      },
      height(n, o) {
        alert(n + 'h')
      },

    },
    created(){
      // this.showClause=true;
      // this.initClause();
      //建议类别枚举
      this.service_code=this.$route.query.service_code;
      this.nav_name=this.$route.query.nav_name;



    },
    methods: {

      onSelectedRegion(v){
        if(this.selectedRegion && this.selectedRegion.length>0){
          this.partyId=this.selectedRegion[this.selectedRegion.length-1];
        }else{
          this.partyId="";
        }

      },


      search(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            const options = {
              city_is:this.ruleForm.BLANTypeCode,
              support_statu:this.ruleForm.ORPTypeCode,
              ability_grade:this.ruleForm.NTFTypeCode,
              archive_type:'NTF',
              part_id:this.partyId
            }
            this.totalShow = false;
            this.loading=true;
            this.$https.post("api/select/selectPaymentAmount.do", options, response => {
              if (response.status === 200 && response.data.code === 200) {
                this.totalShow = true;
                this.total = response.data.data;
                this.loading=false;
              }
            })
          }else {
            this.totalShow = false;
            this.loading=false;
            return
          }
        })
      },
      countDown(times){
        var time;
        if(times){
          time=times;
        }else{
          time=this.$cookies.get("time2")
          if(!time){
            this.smsIsDisabled=false;
            return;
          }
        }
        time=time-1;
        this.$cookies.set("time2",time,time+"s")
        if(time<=0){
          this.smsIsDisabled=false;
          this.smsText="发送短信";
          this.$cookies.remove("time2")
          return
        }else{
          this.smsText=time+"秒"
          var t=this;
          setTimeout(function() {
            t.countDown(time);
          },1000)
        }

      },

      urlTo(url, params) {
        this.$router.push({path: url, query: params || {}});
      },

      checkAge(rule, value, callback) {

        if (value<60) {
          return callback(new Error('请输入大于60的年龄！'))
        } else{
          callback()
        }
      },
      checkDepartId(rule,value,callback){
        if(!this.selectedRegion || this.selectedRegion.length<=0){
          return callback(new Error('请选择受理单位！'))
        }
        return  callback()
      },



    }
  }



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/calculate/NTFCalculation.vue